"use client";

import { extractHrefToSlugWithLinkParams } from "@/utils/extractHrefToSlugWithLinkParams";
import gtmClickEvent from "@/utils/gtmClickEvent";
import { Button } from "@components/ngg";
import type { SplashFragment } from "@server/gql/graphql";
import Link from "next/link";
import { usePathname } from "next/navigation";
import type { ReactNode } from "react";

export default function FurnishingButtonLink({
  children,
  href,
}: {
  children?: ReactNode;
  href?: SplashFragment["href"];
}) {
  const pathname = usePathname();

  if (!children || !href) {
    return null;
  }

  return (
    <Button
      type="button"
      as={Link}
      target="_blank"
      href={extractHrefToSlugWithLinkParams(href)!}
      fullWidth
      className="btn-primary h-12 max-w-sm lg:text-lg print:hidden"
      onClick={() => {
        gtmClickEvent("click_item", {
          eventName: "clickInteriorDesignService",
          url: pathname,
        });
      }}
    >
      {children}
    </Button>
  );
}
